// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { createContext } from 'react';
const defaultValue = {
  defaultProps: {
    size: undefined
  }
};
export const ButtonContext = /*#__PURE__*/createContext(defaultValue);
export const getButtonContextValue = value => ({
  ...defaultValue,
  ...value,
  defaultProps: {
    ...defaultValue.defaultProps,
    ...(value.defaultProps || {})
  }
});
export default ButtonContext;